export default {
  jp: {
    title: {
      list: '申請アカウント一覧',
      detail: 'アカウント詳細'
    },
    error: {
      accountEntryId: {
        notExist: '既に審査が終わっているアカウントです。一覧に戻り、最新の情報を確認してください。'
      },
      accountEntryIds: {
        notExist: '既に審査が終わっているアカウントが含まれています。一覧に戻り、最新の情報を確認してください。'
      }
    },
    label: {
      list: {
        entryDt: '申請日時',
        mailAddress: 'ID',
        name: '氏名',
        busho: '部署',
        telNo: '電話番号'
      },
      detail: {
        mailAddress: 'ID',
        password: 'パスワード',
        name: '氏名',
        group: '所属',
        company: '会社',
        branch: '支社・支局または媒体',
        postNo: '郵便番号',
        prefCd: '都道府県',
        addr1: '市区町村',
        addr2: '番地',
        addr3: 'ビル名',
        busho: '部署',
        telNo: '電話番号',
        remarks: '備考',
        services: '利用希望'
      }
    },
    ph: {
      mailAddress: 'メールアドレスを入力してください',
      name: '氏名を入力してください',
      groupSmall: '選択してください',
      companyId: '選択してください',
      companyName: '「その他」を選択した場合に会社名を入力してください',
      companyNameKana: '「その他」を選択した場合に会社名（カナ）を入力してください',
      branch: '支社・支局または媒体がある場合は選択してください',
      branchName: '「その他」を選択した場合に支社・支局または媒体名を入力してください',
      branchNameKana: '「その他」を選択した場合に支社・支局または媒体名（カナ）を入力してください',
      postNo: '郵便番号を入力してください',
      prefCd: '選択してください',
      addr1: '市区町村を入力してください',
      addr2: '番地を入力してください',
      addr3: 'ビル名を入力してください',
      busho: '部署を入力してください',
      telNo: '電話番号を入力してください',
      password: 'パスワードをリセットする',
      groupAdminFlg: 'グループ責任者に設定する',
      tempStopFlg: 'アカウントを一時的に利用停止に設定する'
    },
    button: {
      new: 'アカウント追加',
      search: '検索',
      reset: '選択行のパスワードをリセット',
      back: '戻る',
      add: '登録する',
      modify: '変更を保存する',
      delete: 'アカウントを削除する',
      detail: {
        back: '戻る',
        approval: '承認',
        reject: '却下'
      }
    },
    desc: {
      list: {
        text1: '申請承認待ちのアカウントの一覧です。',
        text2: '承認または却下するアカウントを選択して、承認または却下してください。',
        text3: 'リンクをクリックすることで詳細を表示できます。詳細から個別に承認または却下をすることも可能です。',
        noData: '申請承認待ちのアカウントは、ありません。',
        approval: '選択行を承認',
        reject: '選択行を却下',
        listCount1: '一覧件数',
        listCount2: '件'
      },
      delete: {
        text1: 'アカウントを削除する場合は、以下のボタンをクリックしてください。'
      }
    }
  },
  en: {
    title: {
      list: 'Applied Accounts',
      add: 'Register Account',
      detail: 'Account Details',
      delete: 'Delete Account'
    },
    error: {
      accountEntryId: {
        notExist: 'This is an account that has already been reviewed. See accounts list and check the latest information.'
      },
      accountEntryIds: {
        notExist: 'It includes accounts that have already been approved. Go back to the list and check for the latest information.'
      }
    },
    label: {
      list: {
        entryDt: 'Application Date',
        mailAddress: 'ID',
        name: 'Name',
        busho: 'Department',
        telNo: 'Phone number'
      },
      detail: {
        mailAddress: 'ID',
        password: 'Password',
        name: 'Name',
        group: 'Group',
        company: 'Company/Organization',
        branch: 'Branch',
        postNo: 'Postal code',
        prefCd: 'Prefecture',
        addr1: 'City',
        addr2: 'Street house number',
        addr3: 'Building Name',
        busho: 'Department',
        telNo: 'Phone number',
        remarks: 'Remarks',
        services: 'Services requested',
        groupAdminFlg: 'Manager setting',
        tempStopFlg: 'Temporarily suspended'
      }
    },
    ph: {
      mailAddress: 'Enter your email address',
      name: 'Enter your name',
      groupSmall: 'Select',
      companyId: 'Select',
      companyName: 'Enter your Company/Organization name if you select "Other".',
      companyNameKana: '',
      branch: 'Select if you have a branch office.',
      branchName: 'Enter your Branch name if you select "Other".',
      branchNameKana: '',
      postNo: 'Enter postal code',
      prefCd: 'Select',
      addr1: 'Enter city',
      addr2: 'Enter street house number',
      addr3: 'Enter building name',
      busho: 'Enter department',
      telNo: 'Enter phone number',
      password: 'Reset Password',
      groupAdminFlg: 'Set up as Group Manager',
      tempStopFlg: 'Temporarily Suspend Account'
    },
    button: {
      new: 'Add account',
      search: 'Search',
      reset: 'Reset password for selected items',
      back: 'Back',
      add: 'Register',
      modify: 'Save',
      delete: 'Delete Account',
      detail: {
        back: 'Back',
        approval: 'Approve',
        reject: 'Reject'
      }
    },
    desc: {
      list: {
        text1: 'A list of accounts pending approval.',
        text2: 'Select approve or reject the account.',
        text3: 'Click link to view details. You can approve or reject from there.',
        noData: 'There are no accounts awaiting approval.',
        approval: 'Approve selected item',
        reject: 'Reject selected item',
        listCount1: 'Count',
        listCount2: 'Items'
      },
      delete: {
        text1: 'Please click below to delete the account.'
      }
    }
  }

}
